export class ConfigCode {
  constructor(
    public readonly code: string,
    private readonly defaultValue: string,
  ) {}

  get default() {
    return this.defaultValue;
  }
}

export const BpCodes = {
  localCountryCode: new ConfigCode('BP-LOCAL-COUNTRY-CODE', 'CL'),
  showSemiLiquidFlow: new ConfigCode('BP-SHOW-SEMI-LIQUID-FLOW', 'false'),
  listIncomePatrimonySegmentation: new ConfigCode('LIST-INCOME-PATRIMONY-SEGMENTATION', ''),
  minimumAumToShowSemiLiquidFlow: new ConfigCode(
    'MINIMUM-AUM-TO-SHOW-SEMI-LIQUID-FLOW',
    '50000000',
  ),
  segmentToShowSemiLiquidFlow: new ConfigCode(
    'SEGMENT-TO-SHOW-SEMI-LIQUID-FLOW',
    'wealth-management',
  ),
  showBpPatrimonyResume: new ConfigCode('SHOW-BP-PATRIMONY-RESUME', 'true'),
  showPaymentButton: new ConfigCode('SHOW-PAYMENT-BUTTON', 'true'),
  discoverNewLabel: new ConfigCode('DISCOVER-NEW-LABEL', 'true'),
  showInsuranceFlow: new ConfigCode('SHOW-INSURANCE-FLOW', 'false'),
  spotOpenTime: new ConfigCode('SPOT-OPEN-TIME', '09:30'),
  spotCloseTime: new ConfigCode('SPOT-CLOSE-TIME', '13:30'),
  forceCloseSpotDate: new ConfigCode('FORCE-CLOSE-SPOT-DATE', ''),
  newSidebarItems: new ConfigCode('NEW-SIDEBAR-ITEMS', 'entity'),
  // ... Otros códigos aquí
};
